import { render, staticRenderFns } from "./DataListVehicule.vue?vue&type=template&id=f20cb7dc&scoped=true&"
import script from "./DataListVehicule.vue?vue&type=script&lang=js&"
export * from "./DataListVehicule.vue?vue&type=script&lang=js&"
import style0 from "./DataListVehicule.vue?vue&type=style&index=0&id=f20cb7dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20cb7dc",
  null
  
)

export default component.exports